export const WRONG_CREDENTIALS = "wrongCredentials"
export const TOO_MANY_REQUESTS = "tooManyRequests"
export const MAXIMUM_FILE_SIZE_ERROR = "maximumFileSizeError"
export const SERVER_ERROR = "serverError"
export const UNAUTHENTICATED_USER = "unauthenticatedUser"
export const UNAUTHORIZED_USER = "unauthorizedUser"
export const NOT_FOUND = "notFound"
export const MIN_LENGTH_ZOD_ERROR = "too_small"
export const INVALID_STRING_ZOD_ERROR = "invalid_string"
